// extracted by css-extract-rspack-plugin
export default {"popover":"popover-3pip9","shadow":"shadow-2PJuP"};